import React from 'react';
import { withStyles } from "tss-react/mui";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogHeader from 'components/DialogHeader';
import QRCodeReaderDialog from 'components/QRCodeReaderDialog';
import QRCodeScannerDialog from 'components/QRCodeScannerDialog';
import ManualLookupDialog from 'areas/cardLookup/components/ManualLookupDialog';
import AuthChooserButton from 'components/AuthChooserButton';
import FabButton from 'components/FabButton';
import { H6, Body1 } from 'components/Typography';
import SwipeListPanel from 'areas/swipes/components/SwipeListPanel';
import filterTypes from 'areas/swipes/components/SwipeListPanel/filterTypes';
import CompetencyMonoIcon from 'components/Icons/Competency/CompetencyMono';
import { isDefined, isString } from 'utilities/is';
import styles from './styles';
import { toShortDateString } from 'utilities/formatters/dateTimeFormatter';
import classNames from 'classnames';
import store from 'utilities/store';
import Keys from 'stateKeys';

class ScanningPage extends React.Component {

    qrReaderDialog = () => {
        return (
            <QRCodeReaderDialog
                title="Scan a QR Code"
                open={this.props.qrDialogOpen}
                handleClose={this.props.closeQRDialog}
                onCardScanned={this.props.handleScan}
                onScanError={this.props.onScanError}
                onVisitorPassScanned={this.props.handleVisitorPassScan}
                config={this.props.config}
            />
        );
    };

    qrScannerDialog = () => {
        return (
            <QRCodeScannerDialog
                title="Scan a QR Code"
                open={this.props.qrScannerOpen}
                handleClose={this.props.closeQRDialog}
                onCardScanned={this.props.handleScan}
                onScanError={this.props.onScanError}
                onVisitorPassScanned={this.props.handleVisitorPassScan}
                config={this.props.config}
            />
        );
    };

    manualLookupDialog = () => {
        return (
            <ManualLookupDialog
                open={Boolean(this.props.manualLookupDialogOpen)}
                handleClose={this.props.closeManualLookupDialog}
                cardNumberLabel={this.props.config.productNumberName}
                onSubmit={this.props.handleManualLookup} />
        );
    };

    openCompetenceDescriptionButton() {

        const { activeCompetenceDocumentationFileId, classes } = this.props;
        const token = store.get(Keys.Auth.TokenKey);

        const className = classNames(classes.evidenceButton, classes.evidenceAttached);
        return (
            <form action='/api/v1/data/competenceDescription' method='post' target='_blank'>
                <input type='hidden' id='id' name='id' value={activeCompetenceDocumentationFileId} />
                <input type='hidden' id='cacheKey' name='cacheKey' value={token} />
                <FabButton key="description" color="secondary" type="submit" className={className}>
                    View competence description
                </FabButton>
            </form>
        );
    }

    fabButtons() {
        const { groupEvidenceSelected, classes, activeCompetenceHasDescriptionAttached, activeCompetenceCanAddEvidence, activeCompetenceEvidenceRequired } = this.props;

        const buttonText = groupEvidenceSelected ? 'Group Evidence Attached' : 'Add Group Evidence';
        const buttonColour = groupEvidenceSelected ? 'secondary' : 'primary';

        let className = "";
        if (groupEvidenceSelected) {
            className = classNames(classes.evidenceButton, classes.evidenceAttached);
        } else {
            className = classes.evidenceButton;
        }

        const viewCompetenceDescriptionRightPosition = activeCompetenceEvidenceRequired && !groupEvidenceSelected ? 560 : 230;

        return (

            <div>

                {activeCompetenceCanAddEvidence && (activeCompetenceHasDescriptionAttached &&
                    <div style={{ position: 'fixed', bottom: 20, right: viewCompetenceDescriptionRightPosition }}>
                        {this.openCompetenceDescriptionButton()}
                    </div>
                )}

                {activeCompetenceEvidenceRequired && !groupEvidenceSelected &&
                    <div style={{ position: 'fixed', bottom: 34, right: 450 }}>
                        <Body1>
                            Evidence is required for this competency
                        </Body1>
                    </div>
                }

                <div style={{ position: 'fixed', bottom: 20, right: 20 }}>

                    

                    {activeCompetenceCanAddEvidence &&
                        <FabButton onClick={this.props.onGroupEvidenceClicked} color={buttonColour} className={className}>
                            {buttonText}
                        </FabButton>
                    }

                    <AuthChooserButton
                        text="Award"
                        icon={CompetencyMonoIcon}
                        qrCodeClicked={this.props.openQRDialog}
                        qrScannerClicked={this.props.openQRScannerDialog}
                        forgottenCardClicked={this.props.openManualLookupDialog}
                    />
                </div>

            </div>
        );
    }

    panelHeader() {
        return (<H6>Competencies</H6>);
    }

    filterSwipesByCompetence = () => {
        const activeCompetence = this.props.activeCompetence;
        if (isDefined(activeCompetence) && Boolean(activeCompetence)) {
            return (swipe) => swipe.competenceID === activeCompetence.competenceID;
        }

        return () => false;
    };

    swipePanel() {
        return (
            <SwipeListPanel
                emptyStateMessage={() => "Click the Award button to begin"}
                showEmptyFilterMessage={false}
                swipes={this.props.swipes || []}
                config={this.props.config}
                location={this.props.location}
                supervisorData={this.props.supervisorData}
                currentFilter={filterTypes.Competencies}
                additionalFilterFunc={this.filterSwipesByCompetence()}
                HeaderComponent={this.panelHeader}
            />
        );
    }

    render() {
        const {
            selectedCompetenceName,
            open,
            classes,
            closeScanningPage,
            expiryDate } = this.props;

        const isOpen = Boolean(open);
        let title = `Award competencies for ${selectedCompetenceName}`;
        if (Boolean(expiryDate)) {
            title += ` expiring on ${isString(expiryDate) ? expiryDate : toShortDateString(expiryDate)}`;
        }

        return (
            <Dialog fullScreen open={isOpen} className={classes.body}>
                <DialogHeader
                    title={title}
                    handleClose={closeScanningPage}
                    showBackIcon={true} />
                <DialogContent className={classes.body}>
                    {this.qrReaderDialog()}
                    {this.qrScannerDialog()}
                    {this.manualLookupDialog()}
                    {this.swipePanel()}
                    {this.fabButtons()}
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(ScanningPage,styles);